export enum QuoteSource {
    CONTRACT = 1,
    AUCTION = 2,
    DIRECT_SALES = 3,
    EDI = 4
}